import React from 'react';

const IconLayoutOne = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89"
            height="89"
            viewBox="0 0 89 89"
            fill="none"
        >
            <g filter="url(#filter0_di_5851_16015)">
                <path
                    d="M2 6.23153C2 3.89452 3.89452 2 6.23152 2H80.9236C83.2606 2 85.1551 3.89452 85.1551 6.23152V80.9236C85.1551 83.2606 83.2606 85.1551 80.9236 85.1551H6.23153C3.89452 85.1551 2 83.2606 2 80.9236V6.23153Z"
                    shape-rendering="crispEdges"
                />
                <rect
                    x="24.5"
                    y="23.0098"
                    width="15.7347"
                    height="40.8367"
                    stroke="#303030"
                    stroke-opacity="0.5"
                />
                <rect
                    x="48.7651"
                    y="23.0098"
                    width="15.7347"
                    height="40.8367"
                    stroke="#303030"
                    stroke-opacity="0.5"
                />
            </g>
        </svg>
    );
};

export default IconLayoutOne;
